const formateaRut = function(rut) {
  let actual = rut.replace(/^0+/, "");
  let rutPuntos = "";
  if (actual != "" && actual.length > 1) {
    let sinPuntos = actual.replace(/\./g, "");
    let actualLimpio = sinPuntos.replace(/-/g, "");
    let inicio = actualLimpio.substring(0, actualLimpio.length - 1);
    let j = 1;
    for (let i = inicio.length - 1; i >= 0; i--) {
      let letra = inicio.charAt(i);
      rutPuntos = letra + rutPuntos;
      if (j % 3 == 0 && j <= inicio.length - 1) {
        rutPuntos = "." + rutPuntos;
      }
      j++;
    }
    let dv = actualLimpio.substring(actualLimpio.length - 1);
    rutPuntos = rutPuntos + "-" + dv;
  } else {
    rutPuntos = rut;
  }
  return rutPuntos;
};

//Funcion para
const formatearSerie = function(serie) {
  let actual = serie.replace(/^0+/, "");
  let seriePuntos = "";
  if (actual != "" && actual.length > 1) {
    if (actual.charAt(0) === "A" || actual.charAt(0) === "a") {
      let sinPuntos = actual.replace(/\./g, "");
      seriePuntos = sinPuntos;
    } else {
      let sinPuntos = actual.replace(/\./g, "");
      let actualLimpio = sinPuntos.replace(/-/g, "");
      let inicio = actualLimpio;
      let j = 1;
      for (let i = inicio.length - 1; i >= 0; i--) {
        let letra = inicio.charAt(i);
        seriePuntos = letra + seriePuntos;
        if (j % 3 == 0 && j <= inicio.length - 1) {
          seriePuntos = "." + seriePuntos;
        }
        j++;
      }
    }
  } else {
    seriePuntos = serie;
  }
  return seriePuntos;
};

//funcion para validacion de digito verificador
const digitoVerificador = function(run) {
  if (run) {
    let runSeparado = separarRun(run);
    let verificador = runSeparado.digitoVerificador;
    let cadena = runSeparado.run;
    let valor = 0;
    let serie = [2, 3, 4, 5, 6, 7];

    for (var i = 0; i < cadena.length; i++) {
      valor =
        valor + Number(cadena.charAt(cadena.length - (i + 1))) * serie[i % 6];
    }

    valor = 11 - (valor % 11);

    if (valor === 10) {
      return /^(k|K)$/.test(verificador);
    } else if (valor === 11) {
      return verificador === "0";
    } else {
      return Number(verificador) === valor;
    }
  }
  return false;
};

//funcion separadora de Rut
const separarRun = function(string) {
  return {
    digitoVerificador: string.substr(string.length - 1),
    run: string
      .slice(0, -1)
      .split(".")
      .join("")
      .replace("-", "")
  };
};

export default {
  formateaRut,
  digitoVerificador,
  formatearSerie
};



// WEBPACK FOOTER //
// ./src/assets/js/formatoRut.js